<template>
  <modal-base class="c-modal--full" v-bind="$attrs" @close="close">
    <div class="c-modal__header">
      <div class="c-modal__header-action c-modal__header-action--left" @click="$emit('clickSecondary')">
        <slot name="headerActionSecondary"></slot>
      </div>
      
      <div class="c-modal__header-content">
        <slot name="header"></slot>
      </div>

      <div class="c-modal__header-action c-modal__header-action--right" @click.stop="close">
        <span class="c-modal__header-close-label" v-if="closeLabel">{{ closeLabel }}</span> <svg class="icon icon-cancel icon-primary c-modal__header-close-icon"><use xlink:href="#icon-cancel"></use></svg>
      </div>
    </div>

    <div class="c-modal__content">
      <slot></slot>
    </div>
  </modal-base>
</template>

<script>
  import ModalBase from './ModalBase.vue';

  export default {
    name: 'ModalFull',
    
    components: {
      ModalBase
    },

    props: {
      closeLabel: {
        type: String,
        default: ''
      }
    },

    methods: {
      close () {
        this.$emit('close');
        this.$modal.remove();
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/modals/ModalFull.vue